import { signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth';
import { auth, googleProvider } from '../firebase-config';
/**
 * Get Google Access Token, refreshing if missing
 */
export const getOrRefreshAccessToken = async () => {
    let accessToken = localStorage.getItem('googleAccessToken');
    if (accessToken) return accessToken;
    // Only try to refresh if user is already authenticated and this is not during initial login
    const user = auth.currentUser;
    if (user && user.providerData && user.providerData[0] && user.providerData[0].providerId === 'google.com') {
        // Optionally: Only allow popup if a flag is set (e.g., user explicitly requests refresh)
        // For now, do NOT trigger popup automatically to avoid double sign-in
        // Return null or throw to let UI handle login flow
        return null;
    }
    // Not authenticated or no access token, do not trigger popup
    return null;
};


/**
 * Sign in with Google - Handles both NEW USER REGISTRATION and existing user login
 * 
 * Returns both tokens needed:
 * - ID Token: For authenticating to Cloud Run backend
 * - Access Token: For accessing Google APIs (Sheets, Drive, Calendar)
 */
export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;

        // Get Firebase ID token (for Cloud Run authentication)
        const idToken = await user.getIdToken();

        // Get Google Access Token (for Google APIs)
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const accessToken = credential.accessToken;
        const refreshToken = user.refreshToken;

        // Check if new user
        const isNewUser = result._tokenResponse?.isNewUser || false;

        console.log(isNewUser ? '🎉 New user registered!' : '👋 User logged in');

        return {
            user,
            idToken,
            accessToken,
            refreshToken,
            isNewUser
        };
    } catch (error) {
        console.error('Sign-in error:', error);
        throw error;
    }
};

/**
 * Sign out user
 */
export const signOutUser = async () => {
    try {
        await signOut(auth);
        localStorage.removeItem('firebaseIdToken');
        localStorage.removeItem('googleAccessToken');
        localStorage.removeItem('googleRefreshToken');
    } catch (error) {
        console.error('Sign-out error:', error);
        throw error;
    }
};

/**
 * Get current Firebase ID token (always fresh)
 */
export const getIdToken = async () => {
    const user = auth.currentUser;
    if (user) {
        // Get fresh token, force refresh if needed
        const token = await user.getIdToken(false);
        console.log('🔑 Got Firebase ID token:', token ? token.substring(0, 20) + '...' : 'null');
        return token;
    }
    console.warn('⚠️ No Firebase user, cannot get ID token');
    return null;
};

/**
 * Get stored Google Access token
 */
export const getAccessToken = () => {
    return localStorage.getItem('googleAccessToken');
};
